<template>
    <div class="home-page">
        <Public></Public>
        <div class="home-content right-content">
            <div class="home-first-row">
                <div class="home-first-row-left">
                    <div class="row-title">
                        <img src="../assets/house.png" alt="">
                        <div class="row-title-content">房源数据</div>
                    </div>
                    <div class="row-content">
                        <div class="row-content-row">
                            <div class="row-content-row-left">
                                总房间：<span class="row-num-green">{{data_all.SumFlat + ""}}</span>
                            </div>
                            <div class="row-content-row-right">
                                欠费：<span class="row-num pointer" @click="toOweFlatTable">{{data_all.SumOweFlat + ""}}</span>
                            </div>
                        </div>
                        <div class="row-content-row">
                            <div class="row-content-row-left">
                                已入住：<span class="row-num-green">{{data_all.SumFlat- data_all.SumEmptyFlat}}</span>
                            </div>
                            <div class="row-content-row-right">
                                离线：<span class="row-num pointer" @click="toOfflineFlatTable">{{data_all.SumOfflineFlat + ""}}</span>
                            </div>
                        </div>
                        <div class="row-content-row">
                            <div class="row-content-row-left">
                                空置数：<span class="row-num-green">{{data_all.SumEmptyFlat}}</span>
                            </div>
                            <div class="row-content-row-right">
                                异常：<span class="row-num pointer" @click="toAbnormalFlatTable">{{data_all.SumAbnormal + ""}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="home-first-row-right">
                    <div class="row-title">
                        <img src="../assets/power.png" alt="">
                        <div class="row-title-content">电表数据</div>
                    </div>
                    <div class="row-content">
                        <div class="row-content-row">
                            <div class="row-content-row-left">
                                总用电量：<span class="row-num-green">{{Number(data_all.SumPower).toFixed(2) + "°"}}</span>
                            </div>
                            <div class="row-content-row-right">
                                在线设备：<span class="row-num-green">{{data_all.SumAmmeter-data_all.SumOfflineAmmeter}}</span>
                            </div>
                        </div>
                        <div class="row-content-row">
                            <div class="row-content-row-left">
                                上月耗电：<span class="row-num-green">{{Number(data_all.MonthPower).toFixed(2) + "°"}}</span>
                            </div>
                            <div class="row-content-row-right">
                                离线设备：<span class="row-num pointer" @click="toOfflineAmmeterTable">{{data_all.SumOfflineAmmeter + ""}}</span>
                            </div>
                        </div>
                        <div class="row-content-row">
                            <div class="row-content-row-left">
                                昨日耗电：<span class="row-num-green">{{Number(data_all.YesterdayPower).toFixed(2) + "°"}}</span>
                            </div>
                            <div class="row-content-row-right">
                                异常设备：<span class="row-num pointer" @click="toAbnormalAmmeterTable">{{data_all.SumAbnormalAmmeter + ""}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="home-second-row">
                <div class="home-first-row-left">
                    <div class="row-title">
                        <div class="row-title-body">
                            <img src="../assets/Chart1.png" alt="">
                            <div class="row-title-content">月度数据统计</div>
                        </div>
                        <div class="date-select">
                            <el-date-picker class="data-picker" v-model="month" type="month" placeholder="选择月" format="yyyy 年 MM 月" value-format="yyyy-MM" @change="drawPie"></el-date-picker>
                        </div>
                    </div>
                    <div class="row-content">
                        <div id="month-chart"></div>
                        <div class="row-content-right">
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    本月收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{ordermoney}}</span>
                                </div>
                            </div>
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    支付宝收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{alipayMoney}}</span>
                                </div>
                            </div>
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    微信收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{weixinpayMoney}}</span>
                                </div>
                            </div>
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    银行卡收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{mspayMoney}}</span>
                                </div>
                            </div>
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    线下收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{offpayMoney}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="home-first-row-right">
                    <div class="row-title">
                        <div class="row-title-body">
                            <img src="../assets/Chart2.png" alt="">
                            <div class="row-title-content">年度数据统计</div>
                        </div>
                        <div class="date-select">
                            <el-date-picker class="data-picker" v-model="year" type="year" placeholder="选择年" format="yyyy 年" value-format="yyyy" @change="drawLine"></el-date-picker>
                        </div>
                    </div>
                    <div class="row-content">
                        <div id="year-chart"></div>
                        <div class="row-content-right">
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    年收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{ordermoneynum}}</span>
                                </div>
                            </div>
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    一季度收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{array1}}</span>
                                </div>
                            </div>
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    二季度收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{array2}}</span>
                                </div>
                            </div>
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    三季度收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{array3}}</span>
                                </div>
                            </div>
                            <div class="row-content-right-item">
                                <div class="row-content-right-item-title">
                                    四季度收入
                                </div>
                                <div class="row-content-right-item-data">
                                    <span class="row-num">￥{{array4}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Public from '@/views/Public.vue'
    import Echarts from "../components/Echarts";
    import store from "../store";

    let echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/title');
    require('echarts/lib/chart/pie');
    require('echarts/lib/component/legend');

    export default {
        name: "newHome",
        components: {
            Echarts,
            Public,
        },
        data() {
            return {
                data_all:'',
                ordermoney: 0,
                alipayMoney: 0,
                weixinpayMoney: 0,
                mspayMoney: 0,
                offpayMoney: 0,
                ordermoneynum: 0,
                array1: 0,
                array2: 0,
                array3: 0,
                array4: 0,
                current_time: "",
                month: "",
                year: "",
            };
        },
        mounted() {
            if (window.localStorage.isChild == 1) {
                this.$router.push('/house');
            } else {
                this.getData();
                this.current_time = store.getters.getNowFormatDateVal;
                this.month = this.current_time.substring(0, 7);
                this.year = this.current_time.substring(0, 4);
                this.drawLine();
                this.drawPie();
            }
        },
        methods: {
            getData() {
                this.$http.get(`${store.state.url}zone/allsum?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.data_all=res.Data;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            drawLine() {
                var begin_month = this.year + "-01";
                var end_month = this.year + "-12";

                this.$http.get(`${store.state.url}finance/financeAggregation/`+ begin_month + `/` + end_month + `/${window.localStorage.userid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        var datemonth = this.year;
                        var myArray = new Array();
                        var myArray_toFixed = new Array();
                        var ordermoneynum = 0;
                        for (var j = 0; j < 12; j++) {
                            var month = "01";
                            var ordermoney = 0;
                            if ((j + 1) < 10) {
                                month = "0" + (j + 1);
                            } else {
                                month = (j + 1);
                            }
                            for (var i in res.Data) {
                                if (res.Data[i].month == (datemonth + "-" + month)) {
                                    ordermoney = (res.Data[i].ordermoney + res.Data[i].xordermoney);
                                }
                            }
                            ordermoneynum += ordermoney;
                            myArray.push(ordermoney);
                            myArray_toFixed.push(ordermoney.toFixed(2));
                        }
                        this.ordermoneynum = ordermoneynum.toFixed(2);
                        this.array1 = (myArray[0] + myArray[1] + myArray[2]).toFixed(2);
                        this.array2 = (myArray[3] + myArray[4] + myArray[5]).toFixed(2);
                        this.array3 = (myArray[6] + myArray[7] + myArray[8]).toFixed(2);
                        this.array4 = (myArray[9] + myArray[10] + myArray[11]).toFixed(2);

                        //柱状图
                        let myChart = echarts.init(document.getElementById('year-chart'));
                        window.addEventListener("resize", function(){
                            myChart.resize();
                        });
                        // var yMax = 500;
                        // var dataShadow = [];
                        // for (var i = 0; i < myArray_toFixed.length; i++) {
                        //     dataShadow.push(yMax);
                        // }

                        myChart.setOption({
                            tooltip: {},
                            grid: {
                                left: 70,
                                bottom: 25,
                            },
                            xAxis: {
                                data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
                            },
                            yAxis: {
                                type: 'value',
                            },
                            series: [
                                {
                                    name: '收入',
                                    type: 'bar',
                                    itemStyle: {
                                        normal: {
                                            color: new echarts.graphic.LinearGradient(
                                                0, 0, 0, 1,
                                                [
                                                    {offset: 0, color: '#108ee9'},
                                                    {offset: 1, color: '#C2DBFF'}
                                                ]
                                            )
                                        }
                                    },
                                    data: myArray_toFixed,
                                    barWidth: '50%',
                                    markPoint: {
                                        data: [
                                            {type: 'max', name: '最大值'},
                                            {type: 'min', name: '最小值'}
                                        ]
                                    }
                                }
                            ]
                        });
                    })
            },
            drawPie() {
                this.$http.get(`${store.state.url}finance/financeAggregation/${this.month}/${this.month}/${window.localStorage.userid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        var ordermoney = 0;
                        var alipayMoney = 0;
                        var weixinpayMoney = 0;
                        var mspayMoney = 0;
                        var offpayMoney = 0;
                        for (let i in res.Data) {
                            ordermoney = res.Data[i].ordermoney + res.Data[i].xordermoney;
                            alipayMoney = res.Data[i].zordermoney;
                            weixinpayMoney = res.Data[i].wordermoney;
                            mspayMoney = res.Data[i].mordermoney;
                            offpayMoney = res.Data[i].xordermoney;
                        }
                        this.ordermoney = ordermoney.toFixed(2);
                        this.alipayMoney = alipayMoney.toFixed(2);
                        this.weixinpayMoney = weixinpayMoney.toFixed(2);
                        this.mspayMoney = mspayMoney.toFixed(2);
                        this.offpayMoney = offpayMoney.toFixed(2);
                        let all = this.ordermoney;

                        //环形图
                        var chart = echarts.init(document.getElementById('month-chart'));
                        window.addEventListener("resize", function(){
                            chart.resize();
                        });
                        chart.setOption({
                            tooltip: {
                                trigger: 'item',
                                formatter: "{a} <br/>{b} : {c} ({d}%)"
                            },
                            grid: {
                                left: 0,
                                bottom: 65,
                            },
                            legend: {
                                orient: 'horizontal',
                                y: 'bottom',
                                x: 'center',
                                data: ['支付宝', '微信', '银行卡', '线下'],
                            },

                            series: [
                                {
                                    name: '收入情况',
                                    type: 'pie',
                                    radius: ['50%', '70%'],
                                    avoidLabelOverlap: false,
                                    label: {
                                        // normal: {
                                        //     show: false,
                                        //     position: 'top',
                                        // },
                                        normal: {
                                            show: true,
                                            position: 'center',
                                            formatter:function (argument) {
                                                return '￥'+ all;
                                            },
                                            textStyle:{
                                                fontSize: 20,
                                                color:'#111'
                                            }
                                        }
                                    },
                                    labelLine: {
                                        normal: {
                                            show: false
                                        }
                                    },
                                    data: [
                                        {value: alipayMoney, name: '支付宝'},
                                        {value: weixinpayMoney, name: '微信'},
                                        {value: mspayMoney, name: '银行卡'},
                                        {value: offpayMoney, name: '线下'}
                                    ]
                                }
                            ]
                        });
                    })
            },
            toOweFlatTable() {
                this.$router.push('/abnormal');
                store.commit('assignAbnormalTableTabIndex', "2");
            },
            toAbnormalFlatTable() {
                this.$router.push('/abnormal');
                store.commit('assignAbnormalTableTabIndex', "3");
            },
            toOfflineFlatTable() {
                this.$router.push('/abnormal');
                store.commit('assignAbnormalTableTabIndex', "1");
            },
            toOfflineAmmeterTable() {
                this.$router.push('/abnormal');
                store.commit('assignAbnormalTableTabIndex', "1");
            },
            toAbnormalAmmeterTable() {
                this.$router.push('/abnormal');
                store.commit('assignAbnormalTableTabIndex', "1");
            },
        }
    }
</script>

<style scoped>
    .home-page {
        height: 100%;
    }
    .home-content {
        height: 94%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        font-size: 2.8vmin;
        white-space: nowrap;
    }
    .home-first-row, .home-second-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        /*margin-bottom: 5%;*/
        padding-bottom: 2%;
        padding-left: 2vw;
    }
    .home-first-row {
        height: 43%;
    }
    /*.home-second-row {*/
        /**/
    /*}*/
    .home-first-row>div, .home-second-row>div {
        /*padding-left: 0.4rem;*/
        width: 45%;
        height: 100%;
        background: #fff;
    }
    .row-title{
        height: 20%;
        font-size: 3vh;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 1vmin;
    }
    .row-title .row-title-body {
        display: flex;
        align-items: center;
        width: 50%;
        justify-content: left;
    }
    .row-title img {
        width: 4vmin;
        height: 4vmin;
        margin-right: 2vmin;
    }
    .home-second-row .row-title {
        justify-content: space-between;
    }
    .data-picker {
        width: 80%;
        font-size: 1.3vw;
    }
    .row-content-row {
        display: flex;
        justify-content: left;
        margin-bottom: 6vmin;
    }
    .row-content-row>div:first-child {
        width: 60%;
        padding-right: 2%;
    }
    .home-second-row .row-content {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 1vw;
    }
    #year-chart, #month-chart {
        height: 42vmin;
        width: 30vw;
    }

    .row-num {
        color: red;
    }
    .row-num-green {
        color: darkseagreen;
    }
    .pointer {
        cursor: pointer;
    }
</style>
